<a *ngIf="link" class="text" [routerLink]="[link, id]">{{ text }}</a>
<ng-container *ngIf="!link">{{ text }}</ng-container>